
import React from 'react'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc'
import { useSearchConditionPc } from '../hooks/useSearchCondition';
import { SelectProps } from 'antd';

export interface FilterClientTypePcProps extends SelectProps {

}  


export const FilterClientType = (props: FilterClientTypePcProps) => {
  const { searchCondition, loading, getInitData } = useSearchConditionPc({ client: ['type'] });
  const { placeholder = '客户类型', ...reset } = props;
  let options = (searchCondition.client?.type ||[])
  

  return <FilterSelectPc
    mode='multiple'
    defaultFilterOption
    options={options}
    getInitData={getInitData}
    loading={loading}
    placeholder={placeholder}
    {...reset}
  />
}